import { Image, Link } from '@akinon/next/components';
import { SwiperReact, SwiperSlide } from '@theme/components';

export const SpecialPageStore = ({ data }) => {
  if (data?.attributes?.triple_banner?.length < 1) return null;
  return (
    <>
      <div className="mt-10 hidden px-2.5 lg:px-0 md:flex gap-9">
        {data?.attributes?.triple_banner?.map((banner, index) =>
          banner?.value?.link ? (
            <Link href={banner?.value?.link} key={index}>
              <Image
                src={banner?.kwargs?.value?.image?.url}
                alt={banner?.value?.alt}
                width={530}
                imageClassName="rounded-2xl"
                className="rounded-2xl"
                height={710}
                key={index}
              />
            </Link>
          ) : (
            <Image
              src={banner?.kwargs?.value?.image?.url}
              alt={banner?.value?.alt}
              width={530}
              height={710}
              imageClassName="rounded-2xl"
              className="rounded-2xl"
              key={index}
            />
          )
        )}
      </div>
      <div className="md:hidden mt-5 pl-2.5 ">
        <SwiperReact slidesPerView={1.25} spaceBetween={10}>
          {data?.attributes?.triple_banner?.map((banner, index) => (
            <SwiperSlide key={index}>
              {banner?.value?.link ? (
                <Link href={banner?.value?.link} key={index}>
                  <Image
                    src={banner?.kwargs?.value?.image?.url}
                    alt={banner?.value?.alt}
                    fill
                    aspectRatio={530 / 710}
                    imageClassName="rounded-2xl"
                    className="rounded-2xl"
                    sizes="(max-width: 640px) 100vw, 530px"
                    key={index}
                  />
                </Link>
              ) : (
                <Image
                  src={banner?.kwargs?.value?.image?.url}
                  alt={banner?.value?.alt}
                  fill
                  aspectRatio={530 / 710}
                  imageClassName="rounded-2xl"
                  className="rounded-2xl"
                  sizes="(max-width: 640px) 100vw, 530px"
                  key={index}
                />
              )}
            </SwiperSlide>
          ))}
        </SwiperReact>
      </div>
    </>
  );
};
